import styles from "./Rebates.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { motion } from "framer-motion";
import {
  DownloadStatementIcon,
  TransferIscon,
} from "../../../../assets/svgIcons";
import useAllTransaction from "./useRebates";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../../../helpers";
import FundsMovement from "../../../../components/secondaryComponents/FundsMovement";
const Rebates = () => {
  const {
    fundsMovement,
    setFundsMovement,
    startDate,
    gotoPage,
    endDate,
    setDateFilter,
    isDownloadStatement,
    setIsDownloadStatement,
    isLoadingRebatesSupplierListing,
    rebatesAccount,
    Transactions,
    isLoadingTransactions,
    selectedRebates,
    setSelectedRebates,
    handleFetchTransactions,
    searchByLedgerAccount,
  } = useAllTransaction();
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Rebates Accountings Transaction"
      description="View all Rebates accountings Transaction"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          className={` ${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
            <div>
              <h4 className="font-weight-semibold">Rebate</h4>
              <p className="default-text-size">
                A check & balance of all your applied rebates
              </p>
            </div>
            <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
              <secondaryComponents.ToolTipV2
                tipText="Download Statement of Account"
                position="left"
              >
                <primaryComponents.Button
                  classNames={"btn btn--outline"}
                  style={{ padding: "0 15px" }}
                  onClick={() => setIsDownloadStatement(true)}
                >
                  <DownloadStatementIcon />
                </primaryComponents.Button>
              </secondaryComponents.ToolTipV2>
              <primaryComponents.Button
                classNames="btn btn--outline"
                onClick={() => setFundsMovement("rebates")}
              >
                <div className="d-flex align-items-center">
                  <TransferIscon />
                  <span className="default-text-size pl-1">Transfer</span>
                </div>
              </primaryComponents.Button>
            </div>
          </div>
          <div
            className={` ${globalStyles.cardWithBorder} mt-3`}
            style={{ background: "#fff" }}
          >
            <div className="d-flex flex-wrap justify-content-between w-100">
              <div className="w-50">
                <p className={`${styles.title} smallest-text-size p-1 mb-2`}>
                  {"Available Balance"}
                </p>
                <secondaryComponents.LoaderHelper
                  isLoading={isLoadingRebatesSupplierListing}
                >
                  <h5
                    className={
                      (selectedRebates?.balance ||
                        rebatesAccount?.[0]?.balance) < 0
                        ? "text-danger"
                        : "text-success"
                    }
                  >
                    {formatCurrency({
                      value:
                        selectedRebates?.balance ||
                        rebatesAccount?.[0]?.balance ||
                        "0",
                      currencyCode: currency_code,
                    })}
                  </h5>{" "}
                </secondaryComponents.LoaderHelper>
              </div>
              <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                <div style={{ width: "200px" }}>
                  <primaryComponents.SelectField
                    options={
                      rebatesAccount
                        ?.filter((rebates) => rebates?.supplier)
                        ?.map((rebates) => ({
                          id: rebates?.supplier?.id,
                          name: rebates?.supplier?.name,
                        })) || []
                    }
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      setSelectedRebates(
                        rebatesAccount?.find(
                          (d) => d?.supplier?.id === value,
                        ) || rebatesAccount?.[0],
                      );
                      searchByLedgerAccount(
                        rebatesAccount?.find((d) => d?.supplier?.id === value)
                          ?.id,
                      );
                    }}
                    value={
                      rebatesAccount?.find((d) => d?.id === selectedRebates?.id)
                        ?.name ||
                      rebatesAccount?.[0]?.supplier?.name ||
                      "Select supplier"
                    }
                    floatError={false}
                    classNames="supplier-name"
                    isSearchable={false}
                  />
                </div>
                <primaryComponents.DateRangeInput
                  startDate={startDate}
                  endDate={endDate}
                  onChange={setDateFilter}
                  classNames=""
                />
              </div>
            </div>
          </div>

          {/* table session */}
          <div className={`${globalStyles.tableWrapper}`}>
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingTransactions}
              classNames={"mt-5"}
            >
              <secondaryComponents.GeneralLedgerTable
                banks={Transactions}
                handleFetchbanks={handleFetchTransactions}
                type="rebates"
                gotoPage={gotoPage}
                metaDetails={Transactions?.meta}
              />
            </secondaryComponents.LoaderHelper>

            {/* funds movement */}
            <secondaryComponents.SideModal
              isActive={fundsMovement !== null}
              closeModal={() => setFundsMovement(null)}
              width={550}
            >
              <FundsMovement
                closeWidget={() => setFundsMovement(null)}
                title="Transfer"
                description="Transfer funds between bank accounts"
                type={fundsMovement}
                rebates={rebatesAccount}
              />
            </secondaryComponents.SideModal>
            <secondaryComponents.SideModal
              isActive={isDownloadStatement}
              closeModal={() => setIsDownloadStatement(false)}
              // width={600}
            >
              <secondaryComponents.StoreWalletDownloadStatement
                closeWidget={() => setIsDownloadStatement(false)}
                selectedStoreId={rebatesAccount?.id}
                type="ledger"
                rebatesAccount={rebatesAccount}
              />
            </secondaryComponents.SideModal>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default Rebates;
